<div class="temporary-popup">
    <app-alert [alertService]="alertService"></app-alert>
  <form [formGroup]="tempPwdForm" novalidate>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
        <h2 class="mg-btm-32">Temporary Password Sent</h2>
        <p>An email was sent you with temporary password. Enter it below and create a new password.</p>
        <p>Didn't get an email?
          <button class="forget-sign-link" [disabled]= "loading" (click)="!loading && resendEmail()">Resend email.</button>
        </p>
      </div>
    </div>
    <div class="row mg-top-32">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="form-group">
          <label for="temporaryPassword">Temporary Password</label>
          <input #tempPassword class="form-control"  formControlName="temporaryPassword" id="temporaryPassword"  type="password" [(ngModel)]="temPassword" />
          <app-validation-message [control]="tempPwdForm.controls.temporaryPassword" class="form-error"></app-validation-message>
        </div>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="form-group">
          <label for="newPassword">Create New Password</label>
          <input class="form-control" formControlName="password" id="newPassword" type="password"/>
          <app-validation-message [control]="tempPwdForm.controls.password" class="form-error"></app-validation-message>
          <div class="password-reqs">
            <p class="text-left">
              <span class="hint-text">Your password must be at least 8 characters (20 max) with no spaces and meeting 2 of these 4 requirements:
                1 Uppercase; 1 Lowercase; 1 Special Character; 1 Number.
              </span>
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="form-group">
            <label for="confirmPassword">Confirm Password</label>
            <input class="form-control" formControlName="confPw" id="confirmNewPassword" type="password"/>
            <app-validation-message [control]="tempPwdForm.controls.confPw" class="form-error"></app-validation-message>
          </div>
        </div>
    </div>
    <div class="row mg-top-12">
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <div class="form-group">
          <button class="btn wb-btn-default center-block" type="submit" [disabled]="!tempPwdForm.valid || loading" (click)="checkTempPwd()">
            Reset Password
            <img alt="reset password" *ngIf="loading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
          </button>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <div class="form-group">
          <button type="submit" class="btn wb-btn-outline center-block" (click)="showModal('app-forgot-password')">Cancel</button>
        </div>
      </div>
    </div>
</form>
</div>
